class ProductFixedBar extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.isPermanentlyClosed = false
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)
    this.listeners.add(document, 'DOMContentLoaded', this.onScroll)
    this.listeners.add(window, 'scroll', this.onScroll)

    this.listeners.add(
      this.productDetailBlocksEl,
      window.BAO.EVENTS.VARIANT.CHANGE,
      this.handleVariantChange.bind(this),
    )
  }

  onScroll () {
    if (!this.productBuyButtonsEl) return
    const showFixedBar = window.BAO.Utils.hasExitedTopOfViewport(
      this.productBuyButtonsEl,
      true,
    )

    this.setAttribute('aria-hidden', !showFixedBar)
    this.bodyEl.classList.toggle(`util-MoveLiveChat`, !!showFixedBar)

    this.bodyEl.classList.toggle(`util-FixedBarVisible`, showFixedBar)
    this.bodyEl.style.setProperty(
      '--FixedBarHeight',
      `${this.getBoundingClientRect()?.height}px`,
    )
  }

  handleVariantChange (event) {
    const variantId = event?.detail?.data?.variant?.id
    const variantEl = this.els?.variant?.element

    if (!event?.detail?.data?.variant?.id || variantEl) return
    variantEl.value = variantId
  }

  hasEl (elementName) {
    return this.els[elementName] && this.els[elementName].exists
  }

  get bodyEl () {
    return window.BAO.Utils.getElement('body', document)
  }

  get productBuyButtonsEl () {
    return window.BAO.Utils.getElement('[data-product-buy-buttons]', document)
  }

  get productDetailBlocksEl () {
    return window.BAO.Utils.getElement('[data-product-detail-blocks]', document)
  }
}

if (!customElements.get('product-fixed-bar')) {
  customElements.define('product-fixed-bar', ProductFixedBar)
}
